import { memo } from 'react';
import { cn } from '@divlab/divanui';

import Img from '@UI/Img';
import images from './images';
import styles from './Tag.module.css';

import type { HTMLAttributes } from 'react';
import type { ProductTagData } from '@Types/Product';

interface Props extends HTMLAttributes<HTMLDivElement> {
  tag: Pick<ProductTagData, 'title'>;
  view?: 'extra' | 'kit';
}

const Tag = (props: Props) => {
  const { tag, view, className, ...restProps } = props;
  const isExtra = view === 'extra';
  const isKit = view === 'kit';

  return (
    <div
      {...restProps}
      className={cn(styles.tag, { [styles.extra]: isExtra, [styles.kit]: isKit }, className)}
      data-testid='product-tag'
    >
      {isExtra && <Img src={images.extra} className={styles.iconExtra} cnImage={styles.cnImage} />}
      {isKit && <Img src={images.plus} className={styles.iconKit} cnImage={styles.cnImage} />}
      {tag.title}
    </div>
  );
};

export default memo(Tag);
